<template>
	<div class="app-wrapper">
		<router-view />
	</div>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
* {
	padding: 0;
	margin: 0;
	box-sizing: border-box;
	font-family: "Raleway", sans-serif;
}

.content {
	width: 80%;
	margin: 0 auto;
}

a {
	text-decoration: none;
	color: inherit;
}

@media screen and (max-width: 760px) {
	.content {
		width: 90%;
	}
}
</style>
